import { RECEIVE_PUBLIC_SETTINGS, RECEIVE_PRIVATE_SETTINGS, FETCH_SETTINGS_REQUEST, RECEIVE_SETTINGS_KO } from '../constants'
import { createReducer } from '../utils/misc'

const initialState = {
    publicData: null,
    privateData: null,
    isFetching: false,
    loaded: false,
    error: false
};

export default createReducer(initialState, {
    [RECEIVE_PUBLIC_SETTINGS]: (state, payload) =>
        Object.assign({}, state, {
            publicData: payload.data,
            privateData: null,
            isFetching: false,
            loaded: true
        }),
    [RECEIVE_PRIVATE_SETTINGS]: (state, payload) =>
        Object.assign({}, state, {
            publicData: null,
            privateData: payload.data,
            isFetching: false,
            loaded: true
        }),
    [FETCH_SETTINGS_REQUEST]: (state) =>
        Object.assign({}, state, {
            isFetching: true,
            loaded: false,
        }),
    [RECEIVE_SETTINGS_KO]: (state) =>
        Object.assign({}, state, {
            isFetching: false,
            loaded: true,
            error: true,
        }),

});
